import { Map } from 'immutable';
import * as Sentry from '@sentry/react';
import { Observable } from 'rxjs';

import { useCountriesQuery, LocationsDocument, CountriesDocument } from '../../generated/graphql';
import { all } from '../../utils/countries';
import Api from '../api';
import { query } from '../graphql';

import Location from './model';
import { addMultipleAction, addAction, updateAction, removeAction } from './actions';

export default class LocationsApi {
  static fetchAll() {
    return Observable.from(query(LocationsDocument))
      .map((result) =>
        addMultipleAction(
          Map(result.data.locations.map((location) => [location.id, new Location(location)]))
        )
      )
      .catch((error) =>
        Api.get('api/locations').map((locations) => [
          addMultipleAction(
            Map(locations.map((location) => [location.id, new Location(location)]))
          ),
          {
            type: 'GRAPHQL_REQUEST_FAILED',
            error,
            request: 'LocationsApi->fetchAll',
          },
        ])
      );
  }

  static fetchAllCountries() {
    return query(CountriesDocument).then((result) => result.data.countries);
  }

  static create(location) {
    return Api.post('api/locations', location).map((persistedLocation) =>
      addAction(new Location(persistedLocation))
    );
  }

  static update(id, location) {
    return Api.patch(`api/locations/${id}`, location).map((updatedLocation) =>
      updateAction(new Location(updatedLocation))
    );
  }

  static delete(id) {
    return Api.delete(`api/locations/${id}`).map(() => removeAction(id));
  }
}

export const useCountries = () => {
  const { data } = useCountriesQuery({ onError: (error) => Sentry.captureException(error) });
  const countries =
    data?.countries ||
    all.map((country) => ({ country: country.name, countryCode: country.alpha2 }));
  return countries.map((country) => new Location(country));
};
